<template>
    <transition name="modal-fade">
        <div class="modal" :class="{'active':isActive}">
            <div class="modal-background absolute inset-0 bg-gradient-to-tr opacity-90 dark:from-gray-700 dark:via-gray-900 dark:to-gray-700 from-gray-700 via-gray-900 to-gray-700 --jb-modal-close" @click="close"></div>
            <div class="modal-card">
                <header class="modal-card-head dark:bg-gray-900 dark:border-gray-800 border-gray-100">
                    <p class="modal-card-title text-2xl">
                        <slot name="header"></slot>
                    </p>
                </header>
                <section class="modal-card-body dark:bg-gray-900 dark:border-gray-800 border-gray-100">
                    <slot name="body"></slot>
                </section>
                <footer class="modal-card-foot dark:bg-gray-900 dark:border-gray-800 border-gray-100">
                    <slot name="footer"></slot>
                </footer>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "Modal",
    props: {
        isActive: false
    },
    methods: {
        close() {
            this.$emit('close');
        },
    },
}
</script>

<style scoped>
.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease;
}
</style>
